import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const CircleCancelIcon: React.FC<Props> = (props) => {
  return (
    <svg
      {...props}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-labelledby="titleId"
      {...props}
     aria-label="circle cancel icon">
      {/* <title>circle cancel icon</title> */}
      <path
        d="M8 0C3.58125 0 0 3.58125 0 8C0 12.4187 3.58125 16 8 16C12.4187 16 16 12.4187 16 8C16 3.58125 12.4187 0 8 0ZM10.5031 9.46875C10.7961 9.76172 10.7961 10.2362 10.5031 10.5294C10.21 10.8225 9.73563 10.8223 9.4425 10.5294L8 9.05937L6.53031 10.5291C6.23716 10.8222 5.76281 10.822 5.46969 10.5291C5.17672 10.2361 5.17672 9.76156 5.46969 9.46844L6.93937 7.99875L5.46875 6.50313C5.17578 6.21016 5.17578 5.73563 5.46875 5.4425C5.76172 5.14937 6.23625 5.14953 6.52938 5.4425L8 6.94063L9.46969 5.47094C9.76266 5.17797 10.2372 5.17797 10.5303 5.47094C10.8234 5.76391 10.8233 6.23844 10.5303 6.53156L9.06063 8.00125L10.5031 9.46875Z"
        fill="#A1A1AA"
      />
    </svg>
  );
};

export default CircleCancelIcon;
